import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';

export default function ResetPasswordModal({ userId, onClose, onReset }) {
  const { theme, isDark } = useTheme();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleReset = async () => {
    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    try {
      await onReset(userId, password);
      onClose();
    } catch (err) {
      setError(err.data?.error || 'Failed to reset password');
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: theme.overlay, backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div onClick={e => e.stopPropagation()} style={{
        width: 400, padding: 28,
        background: isDark ? '#1A1A1E' : '#FFFFFF',
        borderRadius: 14, border: `1px solid ${theme.border}`,
        boxShadow: '0 16px 48px rgba(0,0,0,0.3)',
      }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 700, color: theme.text }}>Reset Password</h3>
        <p style={{ fontSize: 12, color: theme.textMuted, margin: '0 0 20px' }}>
          Set a new password for this user. They can also log in with Google.
        </p>

        {error && (
          <div style={{ padding: '8px 12px', marginBottom: 16, background: theme.redBg, border: `1px solid ${theme.redBorder}`, borderRadius: 8, color: theme.red, fontSize: 12 }}>{error}</div>
        )}

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: theme.textMuted, marginBottom: 6 }}>New Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Min. 8 characters" autoFocus
            onKeyDown={e => { if (e.key === 'Enter') handleReset(); }}
            style={{ width: '100%', padding: '10px 12px', background: theme.bgInput, border: `1px solid ${theme.borderMedium}`, borderRadius: 8, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', fontSize: 12, fontWeight: 500, background: theme.bgInput, border: `1px solid ${theme.borderMedium}`, borderRadius: 8, color: theme.textMuted, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          <button onClick={handleReset} style={{ padding: '10px 24px', fontSize: 12, fontWeight: 600, background: theme.red, border: 'none', borderRadius: 8, color: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>Reset Password</button>
        </div>
      </div>
    </div>
  );
}
